const licensePlateFormatting = (licensePlate: string | undefined): string => {
  const formattedInput = licensePlate ? licensePlate.replace(/\s/g, '') : '';
  const letters = formattedInput.slice(0, 2);
  const numbers = `${formattedInput.slice(2, 4)} ${formattedInput.slice(4, 7)}`;

  return `${letters} ${numbers}`;
};

export default licensePlateFormatting;
